import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InvalidIcon } from 'assets/img/icons/invalid-icon.svg';
import { ErrorMessage } from './styled';

const InputErrorMessage = ({ errorMessage }) => {
  return (
    <ErrorMessage>
      <InvalidIcon />
      {errorMessage}
    </ErrorMessage>
  );
};

InputErrorMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired
};

export default InputErrorMessage;
